<!-- <div class="spinner-overlay" *ngIf="isLoading">
<mat-spinner></mat-spinner>
</div> -->

@if (isLoading) {
  <div class="spinner-overlay">
    <span class="loader"></span>
  </div>
}

